import "./App.css";
import Input from "./components/Input";
import background from "./assets/img/background.png";
import Header from "./components/Header/Header";
import Navbar from "./components/Navbar/Navbar";

<style>
  @import
  url('https://fonts.googleapis.com/css2?family=Inter:wght@400;700&family=Roboto&family=Viga&display=swap');
</style>;

const App = () => {
  return (
    <>
      <Header />
    </>
  );
};

export default App;
